module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-desktop-1220x1500.734523a8.webp";